import { createAction, props } from '@ngrx/store';

export const loadSuppliers = createAction('[Suppliers] Load Suppliers');

export const loadSuppliersSuccess = createAction(
  '[Suppliers] Load Suppliers Success',
  props<{ suppliers: any[] }>()
);

export const loadSuppliersFailure = createAction(
  '[Suppliers] Load Suppliers Failure',
  props<{ error: string }>()
);
